import { getToken } from "./authToken";
import { handleUnauthorizedResponse } from "./authSession";

export interface AgentFetchOptions extends RequestInit {
  /** Skip automatic retry after 401. */
  skipAuthRetry?: boolean;
}

/**
 * Fetch against the agent API with Bearer tenant JWT and one 401 retry after refresh.
 */
export async function agentFetch(
  url: string,
  options: AgentFetchOptions = {},
): Promise<Response> {
  const { skipAuthRetry, headers: initHeaders, ...rest } = options;
  const headers = new Headers(initHeaders);

  const token = getToken();
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  let response = await fetch(url, { ...rest, headers });

  if (response.status !== 401 || skipAuthRetry) {
    return response;
  }

  const refreshed = await handleUnauthorizedResponse();
  if (!refreshed) {
    return response;
  }

  const retryHeaders = new Headers(initHeaders);
  const newToken = getToken();
  if (newToken) {
    retryHeaders.set("Authorization", `Bearer ${newToken}`);
  }

  return agentFetch(url, {
    ...options,
    headers: retryHeaders,
    skipAuthRetry: true,
  });
}
